import { apiFetch } from './api';

export interface KlasseStatusItem {
  id: number;
  name: string;
  schuljahr: string;
  faecher_unterrichtet: string[];
  rolle: string;
  schueler_count: number;
}

export interface UebergangStatus {
  wizard_offen: boolean;
  aktuelles_schuljahr: string;
  naechstes_schuljahr: string;
  log_id: number | null;
  aktive_klassen: KlasseStatusItem[];
  trigger_status: 'inaktiv' | 'soft' | 'hard';
  tage_bis_hard_cutoff: number | null;
}

export interface PromoResult {
  neue_klasse_id: number;
  uebernommene_schueler_count: number;
}

export interface WizardSummary {
  promotioniert?: number;
  archiviert?: number;
  aufgeloest?: number;
  anker_noten_transferiert?: number; // nur noch alte Protokolle (vor Welle N2)
  attest_fortgefuehrt?: number;
  attest_beendet?: number;
}

// Welle J1: Schüler mit aktiver Attestpflicht in Nachfolgeklassen dieses Übergangs
export interface AttestKandidat {
  id: number;
  vorname: string;
  nachname: string;
  attestpflicht_seit: string | null;
  attestpflicht_notiz: string | null;
  klasse_id: number;
  klasse_name: string;
  schuljahr: string;
}

export interface SchuelerMin {
  id: number;
  vorname: string;
  nachname: string;
}

// Welle S4b: lokaler Fetch-Klon entfernt — zentraler apiFetch aus lib/api
export const uebergangApi = {
  status: () =>
    apiFetch<UebergangStatus>('/api/uebergang/status'),

  start: () =>
    apiFetch<{ log_id: number }>('/api/uebergang/start', { method: 'POST' }),

  klasseSchueler: (id: number) =>
    apiFetch<SchuelerMin[]>(`/api/uebergang/klasse/${id}/schueler`),

  archivieren: (id: number, logId: number) =>
    apiFetch<{ ok: boolean }>(`/api/uebergang/klasse/${id}/archivieren`, {
      method: 'POST', body: JSON.stringify({ log_id: logId }),
    }),

  aufloesen: (id: number, logId: number) =>
    apiFetch<{ ok: boolean }>(`/api/uebergang/klasse/${id}/aufloesen`, {
      method: 'POST', body: JSON.stringify({ log_id: logId }),
    }),

  promotionieren: (id: number, data: {
    log_id: number;
    neuer_name: string;
    gewaehlte_faecher: string[];
    uebernommene_schueler_ids: number[];
  }) =>
    apiFetch<PromoResult>(`/api/uebergang/klasse/${id}/promotionieren`, {
      method: 'POST', body: JSON.stringify(data),
    }),

  attestKandidaten: (logId: number) =>
    apiFetch<{ naechstes_schuljahr: string; schueler: AttestKandidat[] }>(`/api/uebergang/attestpflicht?log_id=${logId}`),

  abschluss: (logId: number, attest?: { fortgefuehrt: number; beendet: number }) =>
    apiFetch<{ summary: WizardSummary }>('/api/uebergang/abschluss', {
      method: 'POST', body: JSON.stringify({ log_id: logId, attest }),
    }),
};
